export const en = {
    common: {
        version: 'Version',
        at: 'at',
        or: 'or',
        left: 'left',
        files: 'Files',
        connections: 'Connections',
        personalization: 'Personalization',
        summary: 'My Summary',
        summaries: 'Summaries',
        unknown: 'unknown',
        default: 'Default'
    },
    labels: {
        done: 'Done',
        today: 'Today',
        dashboard: 'Dashboard',
        connections: 'Connections',
        personalization: 'Personalization',
        uploading: 'Uploading...',
        processing: 'Processing...',
        thinking: 'Thinking...',
        detecting: 'Detecting...',
        yesterday: 'Yesterday',
        fileDeletion: 'File deletion',
        noFiles: 'No files yet',
        imageUploaded: 'Image uploaded',
        imageCreated: 'Image created',
        imageRendering: 'Image rendering...',
        loading: 'Loading...',
        connecting: 'Connecting...',
        reconnecting: 'Reconnecting...',
        maintenance: 'System is under maintenance.',
        connected: 'Connected',
        addToContext: 'Add to context',
        noConnections: 'No connections yet',
        joinUs: 'Join Us & Explore',
        signInToStart: 'Sign in to get started',
        signingIn: 'Signing in...',
        signInError: 'Login failed, try again',
        attempt: 'Attempt {{attempt}}',
        changing: 'Changing',
        memory: 'Memory',
        agentTasks: 'Agent tasks',
        photoLibrary: 'Photo Library',
        inherited: 'Inherited',
        notifications: 'Notifications',
        pushNotifications: 'Push notifications',
        pushNotificationsHint: 'Get notified even when the app is closed',
        workedFor: 'Worked for {{duration}}',
        nothingToShow: 'Nothing to show',
        promptsEmpty: 'Prompt records for this message are not available.'
    },
    enums: {
        oauthType: {
            dropbox: 'Dropbox',
            twitter: 'X',
            google: 'Google',
            protonmail: 'Proton mail',
            oura: 'Oura',
            eight_sleep: 'Eight Sleep',
            renpho: 'Renpho'
        },
        serviceGroup: {
            storage: 'Storage',
            social: 'Social Media',
            email: 'Email',
            health: 'Health'
        }
    },
    actions: {
        save: 'Save',
        cancel: 'Cancel',
        close: 'Close',
        reset: 'Reset',
        pin: 'Pin',
        signOut: 'Sign Out',
        download: 'Download',
        downloadMd: 'Download .md',
        delete: 'Delete',
        search: 'Search',
        deleteFile: 'Delete file',
        refresh: 'Refresh',
        connect: 'Connect',
        disconnect: 'Disconnect',
        downloadChat: 'Download Chat History',
        addConnection: 'Add connection',
        setDefault: 'Set Default',
        getStarted: 'Get Started',
        flagResponse: 'Flag this response',
        regenerateAnswer: 'Regenerate answer',
        contextInspector: 'Context inspector'
    },
    fields: {
        name: 'Name',
        topic: 'Topic',
        created: 'Created',
        model: 'Model',
        model_chat: 'Chat model',
        model_voice: 'Voice model',
        model_video: 'Video model',
        agent_name: 'Agent name',
        status: 'Status',
        index: 'Index',
        ms_per_char: 'Typewriter speed, ms per character'
    },
    dropzone: {
        dragDropOr: 'Drag & Drop or ',
        chooseFile: 'Choose file',
        toUpload: 'to upload',
        dropHere: 'Drop File here',
        size: 'up to {{size}} MB allowed',
        formats: 'supported formats'
    },
    placeholders: {
        search: 'Search',
        chat: 'Ask {{name}}',
        enterPrompt: 'Enter prompt'
    },
    toasts: {
        connectionClosed: 'Connection closed',
        responseError: 'Response error',
        unknownMessage: 'Unknown message {{type}}',
        notificationsUnsupported: 'Push notifications are not supported on this device',
        notificationsBlocked: 'Notifications are blocked. Enable them in your device settings',
        notificationsError: 'Failed to enable notifications'
    },
    voice: {
        microphoneOn: 'Turn on microphone',
        microphoneOff: 'Turn off microphone',
        cameraOn: 'Turn on camera',
        cameraOff: 'Turn off camera',
        avatarOn: 'Turn on avatar',
        avatarOff: 'Turn off avatar',
        close: 'Close voice mode',
        settings: 'Settings',
        microphone: 'Microphone',
        speaker: 'Speaker',
        mcpOff: 'Deactivate MCP Tools',
        mcpOn: 'Activate MCP Tools'
    },
    cameraStream: {
        title: 'Live stream cameras',
        serverUrl: 'Server URL',
        streamKey: 'Stream key',
        camera: 'Camera {{number}}',
        cameraStreamKey: 'Camera {{number}} stream key',
        status: 'Status',
        live: 'Live',
        offline: 'Offline',
        share: 'Share',
        copied: 'Copied',
        copyUrl: 'Copy URL',
        copyKey: 'Copy stream key',
        regenerate: 'Regenerate stream key',
        regenerateConfirm: 'The camera will stop streaming until you enter the new key.',
        remove: 'Remove camera'
    },
    messages: {
        fileDeletion: 'Are you sure you want to delete {{name}}?',
        noConnections: 'Connect a service to start syncing your data here',
        maxDocsReached: 'Documents amount is maximum',
        connectionsWebOnly: 'Manage connections is available on the web version.',
        downloadChat: 'All your conversations will be included in the export file. Processing may take some time.'
    },
    avatar: {
        changeImage: 'Change image',
        resetToDefault: 'Reset to default',
        uploadError: 'Only JPG/PNG up to 5 MB allowed',
        cropTitle: 'Crop image',
        zoom: 'Zoom'
    },
    errors: {
        wentWrong: 'Something went wrong...',
        docIsLarge: '{{name}} is too large',
        docIsUnsupported: '{{name}} is not supported',
        uploadFailed: 'Upload failed',
        device: 'Device permissions denied',
        positiveNumber: 'Must be a positive number'
    },
    summary: {
        title: 'Summary',
        newSummary: 'New summary',
        loading: 'Loading…',
        saving: 'Saving…',
        tabs: {
            content: 'Content',
            state: 'State',
            promptSettings: 'Prompt settings'
        },
        list: {
            titleCol: 'Title',
            statusCol: 'Status',
            updatedCol: 'Updated',
            enabledCol: 'Enabled',
            empty: 'No summaries yet',
            emptyDescription: 'User summaries are injected into {{name}} system prompt and shared across text and voice. The first summary is created automatically after your first message.'
        },
        fields: {
            title: 'Title',
            updatePrompt: 'Update prompt',
            wiringPrefix: 'Wiring prefix',
            wiringSuffix: 'Wiring suffix',
            updateEveryTurns: 'Update every turns',
            updateEveryNTurns: 'Update every N turns',
            charLimit: 'Char limit',
            maxAttempts: 'Max attempts',
            content: 'Content',
            status: 'Status',
            enabled: 'Enabled',
            progress: 'Progress',
            lastUpdated: 'Last updated:'
        },
        placeholders: {
            title: 'e.g. My interests, Work context…',
            updatePrompt: 'Leave empty to use the default system prompt'
        },
        validation: {
            titleRequired: 'Title is required',
            titleMaxLength: 'Title must be 200 characters or less',
            minValue: '≥ 1'
        },
        actions: {
            create: 'Create',
            replay: 'Replay',
            cancelReplay: 'Cancel replay',
            retryReplay: 'Retry replay',
            advancedSettings: 'Advanced settings',
            resetToDefaults: 'Reset to defaults',
            resetToDefault: 'Reset to default',
            saveSettings: 'Save settings'
        },
        state: {
            cancel: 'Cancel',
            enabledDescription: 'Active — injected into {{name}} system prompt',
            disabledDescription: 'Off — not injected',
            enabledLabel: 'Enable',
            disabledLabel: 'Disable',
            turnsSinceUpdate: '{{turns}} / {{updateEvery}} turns since last update',
            autoUpdateEvery: 'Auto-update runs every {{updateEvery}} conversation turns'
        },
        content: {
            noContent: 'No summary content yet. It will fill in automatically as you chat with {{name}}, or hit Replay to replay it from history.'
        },
        confirm: {
            deleteTitle: 'Delete this summary?',
            deleteBody: 'This action is irreversible. The content will be permanently removed.',
            replayTitle: 'Replay from history?',
            replayBody: 'Replay this summary from the full conversation history? It may take a while; the current text will be replaced when done.',
            cancelReplayTitle: 'Cancel replay?',
            cancelReplayBody: 'The in-progress replay will be stopped. The summary will revert to its previous content.',
            resetPromptTitle: 'Replace your custom prompt?',
            resetPromptBody: 'Replace your custom prompt with the system default?',
            resetSettingsTitle: 'Reset wiring and update parameters?',
            resetSettingsBody: 'Reset wiring and update parameters to defaults?'
        },
        relativeTime: {
            justNow: 'just now',
            minuteAgo: '{{count}} minute ago',
            minutesAgo: '{{count}} minutes ago',
            hourAgo: '{{count}} hour ago',
            hoursAgo: '{{count}} hours ago',
            dayAgo: '{{count}} day ago',
            daysAgo: '{{count}} days ago'
        }
    },
    memory: {
        title: 'Memory',
        factCount: '{{count}}',
        rebuild: 'Rebuild',
        rebuildStarted: 'Rebuild started. Clusters will refresh shortly.',
        emptyClusters: 'No memories yet',
        emptyClustersDescription: 'Memories are facts {{name}} learns about you over time. They will appear here as you chat.',
        emptyFacts: 'No memories in this cluster'
    },
    notes: {
        title: 'Notes',
        newNote: 'New note',
        editNote: 'Edit note',
        loading: 'Loading…',
        tabs: {
            list: 'Notes',
            settings: 'Settings'
        },
        list: {
            empty: 'No notes yet',
            emptyDescription: 'Notes are short pieces of context {{name}} keeps about you. They will appear here as you chat.'
        },
        fields: {
            enabled: 'Enabled',
            maxNotes: 'Max notes',
            softLimit: 'Soft limit',
            maxNoteLength: 'Max note length',
            ttlEnabled: 'TTL enabled',
            ttlHours: 'TTL (hours)',
            text: 'Note'
        },
        placeholders: {
            text: 'e.g. Prefers concise answers.'
        },
        validation: {
            textRequired: 'Note text is required',
            textMaxLength: 'Note must be {{count}} characters or less'
        },
        actions: {
            create: 'Create a new',
            edit: 'Edit',
            save: 'Save changes',
            saveSettings: 'Save settings'
        },
        confirm: {
            deleteTitle: 'Delete this note?',
            deleteBody: 'This action is irreversible. The note will be permanently removed.'
        }
    },
    agentTasks: {
        title: 'Agent tasks',
        editTask: 'Edit task',
        list: {
            empty: 'No agent tasks yet',
            emptyDescription: 'Agent tasks are one-shot prompts delegated to a remote agent. They will appear here once queued.'
        },
        fields: {
            prompt: 'Prompt',
            status: 'Status'
        },
        placeholders: {
            prompt: 'e.g. Summarize the attached report'
        },
        validation: {
            promptRequired: 'Prompt is required'
        },
        status: {
            pending: 'Pending',
            in_progress: 'In progress',
            accepted: 'Accepted',
            dispatched: 'Dispatched',
            running: 'Running',
            delayed: 'Delayed',
            completed: 'Completed',
            failed: 'Failed',
            cancelled: 'Cancelled',
            missing: 'Missing'
        },
        actions: {
            edit: 'Edit',
            save: 'Save',
            cancelTask: 'Cancel task'
        },
        confirm: {
            deleteTitle: 'Cancel this task?',
            deleteBody: 'This will force-cancel the task. This action cannot be undone.'
        }
    },
    reminders: {
        title: 'Reminders',
        newReminder: 'New reminder',
        editReminder: 'Edit reminder',
        loading: 'Loading…',
        status: {
            active: 'Active',
            paused: 'Paused',
            cancelled: 'Cancelled',
            completed: 'Completed'
        },
        list: {
            empty: 'No reminders yet',
            emptyDescription: 'Reminders run a prompt on a schedule you choose. Create one via chat to have {{name}} reach out automatically.'
        },
        fields: {
            prompt: 'Prompt',
            startAt: 'Start at',
            intervalSeconds: 'Interval',
            repeatCount: 'Repeat count',
            nextRun: 'Next run',
            lastRun: 'Last run',
            runCount: 'Runs'
        },
        placeholders: {
            prompt: 'e.g. Send me a daily summary of my tasks.',
            repeatCount: 'Leave empty for infinite'
        },
        validation: {
            promptRequired: 'Prompt is required',
            startAtRequired: 'Start date is required',
            intervalRequired: 'Interval is required',
            intervalMin: 'Interval must be at least 1 second',
            repeatCountMin: 'Repeat count must be greater than 0'
        },
        actions: {
            create: 'Create a new',
            edit: 'Edit',
            save: 'Save changes',
            pause: 'Pause',
            resume: 'Resume',
            cancel: 'Cancel reminder'
        },
        confirm: {
            cancelTitle: 'Cancel this reminder?',
            cancelBody: 'This action is irreversible. The reminder will stop running.'
        }
    },
    health: {
        title: 'Health & Fitness',
        description: 'Sync your health and fitness data from Apple Health to your account.',
        lastSync: 'Last synced',
        lastBgSync: 'Last synced in the background',
        recentBgSyncs: 'Recent background syncs',
        metricsCount: '{{count}} metrics',
        neverSynced: 'Not synced yet',
        syncNow: 'Sync now'
    },
    location: {
        title: 'Location',
        description: 'Sync your current location to your account.',
        lastSync: 'Last synced',
        neverSynced: 'Not synced yet',
        syncNow: 'Sync now'
    },
    userSync: {
        title: 'Sync user data',
        tabs: {
            health: 'Health & fitness',
            location: 'Location'
        },
        tbdBadge: 'TBD',
        comingSoon: 'Coming soon'
    }
};
//# sourceMappingURL=en.js.map